import { Modal } from 'bootstrap';

export function setModal(modal,type,title,body) {
  let modalContent = modal.querySelector('.modal-content');
  let modalTitle = modal.querySelector('.modal-title');
  let modalBody = modal.querySelector('.modal-body');
  modalContent.className = "";
  modalContent.classList.add('modal-content',type);
  if(title !=='') {
    modalTitle.innerHTML = title;
  }
  if(body !=='') {
    modalBody.innerHTML = body;
  }
}

export function showModal(modal,type,title,body) {
  setModal(modal,type,title,body);

  let theModal = new Modal(modal);
  theModal.show();
}
